import { QueryClient } from '@tanstack/react-query';

// The app's one QueryClient. Kept out of App.tsx so session code (auth-session,
// the axios interceptor) can clear it without importing the whole app.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Returning to a browser tab used to refetch every mounted query at once.
      // Most hooks here already opted out of that one at a time, so make it the
      // default: a tab switch must not fire a burst of authenticated requests at
      // a page holding unsaved work. The queries that genuinely want it — the
      // notification bell — still set `refetchOnWindowFocus: true` themselves.
      refetchOnWindowFocus: false,
    },
  },
});
